import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { getLocalStorageItem, popup } from '../../../utils';
import { LOCAL_STORAGE } from '../../../constants';
import { createChatAPI, getAllChatsAPI } from '../../../utils/apiServices/chatsAPI';
import {
    closeChat,
    initializeChatList,
    resetChatNotification,
    setCurrentView,
    setSelectedUser,
    toggleChatOpen,
} from '../../../redux';
import ChatBody from './ChatBody';
import { CustomerChatHeader } from './CustomerChatHeader';
import { CustomerChatFooter } from './CustomerChatFooter';
import { CURRENT_VIEW } from '../../shared/FloatingChatElement/constant';
import { ChatIcon } from '../../../assets/svg';

export const CustomerChatElement = () => {
    const dispatch = useDispatch();
    const show = useSelector((s) => s.chat.isChatOpen);
    const selectedAccount = useSelector((s) => s.accountArray?.selectedAccount);
    const accounts = useSelector((s) => s.accountArray?.accounts);
    const notifications = useSelector((s) => s.chat.chatNotifications);
    const userId = getLocalStorageItem(LOCAL_STORAGE.USER_ID);
    const [messageSearch] = useState('');
    const isImpersonating = getLocalStorageItem(LOCAL_STORAGE.IS_IMPERSONATING);

    const getChatList = async () => {
        try {
            const account = accounts.find((account) => account.id === selectedAccount);
            if (!account?.csm_id) return;
            const { data: chatData } = await getAllChatsAPI({
                management_id: account?.csm_id,
                search: messageSearch,
                user_id: userId,
            });
            if (isEmpty(chatData[0])) {
                const { data: newChat } = await createChatAPI({
                    management_id: account.csm_id,
                    user_id: userId,
                });
                dispatch(initializeChatList([newChat]));
            } else {
                dispatch(initializeChatList(chatData));
            }
        } catch (error) {
            popup('error', error.message || 'Failed to fetch messages');
        }
    };

    useEffect(() => {
        if (selectedAccount && userId && accounts?.length > 0) {
            getChatList();
        }
        return () => dispatch(closeChat());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAccount, messageSearch, userId]);

    const onClose = async () => {
        dispatch(setSelectedUser({}));
        dispatch(resetChatNotification());
        dispatch(closeChat());
        dispatch(setCurrentView(CURRENT_VIEW.CHAT_VIEW));
    };

    return (
        <div className='floating-chat-container'>
            {!show && (
                <span>
                    <Button
                        className={`floating-chat-btn ${show ? 'open' : ''}`}
                        onClick={() => dispatch(toggleChatOpen())}
                        title='Chat With Your CSM'
                    >
                        <ChatIcon />
                        {notifications > 0 && (
                            <span
                                className='d-flex justify-content-center position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger align-items-center'
                                style={{ fontSize: '12px', width: '22px', height: '22px' }}
                            >
                                {notifications > 99 ? '+99' : notifications}
                                <span className='visually-hidden'>unread messages</span>
                            </span>
                        )}
                    </Button>
                </span>
            )}
            {show && (
                <div className={`chat-panel ${show ? 'open' : ''}`}>
                    <CustomerChatHeader onClose={onClose} />
                    <ChatBody />
                    {!isImpersonating && <CustomerChatFooter />}
                </div>
            )}
        </div>
    );
};
